'use client';

import Image from 'next/image';
import Link from 'next/link';
import { overlay } from 'overlay-kit';

import { LOCATION_INFO } from '@/components/common/terms/terms';
import TermsDialog from '@/components/common/terms/termsDialog';
import { convertCdnUrl } from '@/utils/js/condition';

import styles from './main.module.scss';

export default function Footer() {
  const termsDialog = () => {
    overlay.open(({ isOpen, close }) => {
      return <TermsDialog isOpen={isOpen} close={close} content={LOCATION_INFO} />;
    });
  };
  return (
    <footer>
      <div className={styles.pad}>
        <ul className={styles.terms_list}>
          <li>
            <Link
              href="https://m.aipartner.com/town/town-privacy?public=Y"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>개인정보처리방침</strong>
            </Link>
          </li>
          <li>
            <Link
              href="https://m.aipartner.com/town/town-service?public=Y"
              target="_blank"
              rel="noopener noreferrer"
            >
              서비스 이용약관
            </Link>
          </li>
          <li>
            <Link
              href="https://m.aipartner.com/town/town-location?public=Y"
              target="_blank"
              rel="noopener noreferrer"
            >
              위치기반 서비스 이용약관
            </Link>
          </li>
        </ul>
        <Image
          src={convertCdnUrl('/logo_proptier.svg')}
          alt="프롭티어 sk디스커버리 로고"
          width="172"
          height="32"
          className={styles.company_logo}
        />
        <div className={styles.footer_info}>
          <b>프롭티어(주) 대표자 서동록</b>
          <div className={styles.company_info}>
            <address>서울특별시 서초구 방배로 107, 디엠타워3관</address>
            <p>통신판매신고번호 : 제 2019-서울서초-0765</p>
            <div className="divide_box">
              <p>사업자번호 : 214-87-09557</p>
              <p>고객센터 : 1800-6950</p>
            </div>
          </div>
          <p className={styles.copyright}>&copy; proptier. ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </footer>
  );
}
